import { render, staticRenderFns } from "./economy-company.vue?vue&type=template&id=470133a9&scoped=true"
import script from "./economy-company.vue?vue&type=script&lang=js"
export * from "./economy-company.vue?vue&type=script&lang=js"
import style0 from "./economy-company.vue?vue&type=style&index=0&id=470133a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470133a9",
  null
  
)

export default component.exports